import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import TopFooter from './TopFooter';
import BottomFooter from '@components/footer/BottomFooter';
import Banners from '@components/footer/Banners';
import Popups from '@components/footer/Popups';

const Footer = () => {
  const data = useStaticQuery(graphql`{
    contentfulLayout(title: {eq: "Demo"}) {
      ...Footer
    }
  }`);
  return (
    <footer>
      <TopFooter data={data}/>
      <BottomFooter data={data}/>
      <Banners data={data}/>
      <Popups data={data}/>
    </footer>
  )
}

export default Footer
